import React from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../../_metronic/_helpers";
import { createLibraryFolder } from "../../../_redux/library/libraryAction";
import LoadingAnimation from "../loading-animation/LoadingAnimation";
import LibraryCreateForm from "./LibraryCreateForm";

export default function LibraryCreate({
  show,
  onHide,
  onSubmit,
  defaultValues
}) {
  return (
    <>
      <Modal
        size="md"
        show={show}
        onHide={onHide}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header>
          <h4>
            {defaultValues.uuid
              ? `Update Folder ${defaultValues.name}`
              : "Tambah Folder"}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <LibraryCreateForm
            onSubmit={onSubmit}
            defaultValues={defaultValues}
          />
        </Modal.Body>
      </Modal>
    </>
  );
}
